// extracted by mini-css-extract-plugin
export default {"scoreAttachmentWidgetScoreBar":"UkgVTBXjDImjZnmZXwl4","scoreBarOutside":"r4hxGzffuhCtRUbmAPIZ","scoreBarInside":"W6nI8xruIo0DrmsjR8x4"};